module.exports = __webpack_public_path__ + "app/community/community-stock-software-Sy-6deUB.html";